import _fails from "../internals/fails";
import _globalThis2 from "../internals/global-this";
var exports = {};
var fails = _fails;
var _globalThis = _globalThis2;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = _globalThis.RegExp;
exports = fails(function () {
  var re = $RegExp("(?<a>b)", "g");
  return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
export default exports;